import homeRoutes from '../containers/Home';
import loginRoutes from '../containers/Login';

const routes = [...homeRoutes, ...loginRoutes];

export default routes;
